import { Search, ShieldCheck, PackageCheck, Truck } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const STEP_ICONS = [Search, ShieldCheck, PackageCheck, Truck];

export default function SourcingJourney() {
  const { t } = useLang();
  const j = t.common.journey;

  return (
    <section
      className="py-24 md:py-32 bg-white border-t border-[#E2E8F0]"
      data-testid="sourcing-journey"
    >
      <div className="pgb-container">
        <div className="max-w-3xl mb-14">
          <span className="eyebrow text-[#1D4ED8]">{j.eyebrow}</span>
          <h2 className="mt-4 text-3xl md:text-5xl font-black tracking-tighter text-[#0B1B29]">
            {j.title}
          </h2>
          <p className="mt-5 text-[#536878] leading-relaxed max-w-2xl">
            {j.subtitle}
          </p>
        </div>

        <div className="relative">
          {/* Connecting rail (desktop only) */}
          <div
            aria-hidden="true"
            className="hidden md:block absolute top-[38px] left-[5%] right-[5%] h-[2px] bg-gradient-to-r from-[#1D4ED8] via-[#93C5FD] to-[#F59E0B]"
          />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-6 relative">
            {j.steps.map((step, idx) => {
              const Icon = STEP_ICONS[idx];
              return (
                <div
                  key={idx}
                  className="flex flex-col items-start"
                  data-testid={`journey-step-${idx}`}
                >
                  <div className="relative w-[76px] h-[76px] flex items-center justify-center bg-[#0B1B29] text-white border-4 border-white shadow-[0_8px_30px_rgba(11,27,41,0.15)]">
                    <Icon size={30} className="text-[#F59E0B]" />
                    <span className="absolute -top-2 -right-2 bg-[#F59E0B] text-[#0B1B29] w-7 h-7 flex items-center justify-center font-black text-xs border-2 border-white">
                      0{idx + 1}
                    </span>
                  </div>

                  <h3 className="mt-6 text-lg md:text-xl font-bold text-[#0B1B29] tracking-tight">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-sm text-[#536878] leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
